import { ComponentChildren, ComponentType } from "preact";
import { IconProps } from "../../icons";
import { useConfigContext } from "../../context/config-context";
import * as styles from "./button.css";

type ButtonProps = {
  onClick?: () => void;
  variant?: "primary" | "secondary" | "link" | "link-white";
  size?: "sm" | "md" | "lg";
  className?: string;
  Icon?: ComponentType<IconProps>;
  iconPosition?: "left" | "right";
  id?: string;
  disabled?: boolean;
  children?: ComponentChildren;
};

export const Button = ({
  onClick,
  variant = "primary",
  size = "md",
  className = "",
  Icon,
  iconPosition = "left",
  children,
  disabled,
  id,
}: ButtonProps) => {
  const { styleImportant } = useConfigContext();
  const variantStyles = styleImportant
    ? styles.importantVariant
    : styles.defaultVariant;
  const iconColor =
    variant === "secondary" || variant === "link"
      ? "var(--widget-primary)"
      : "white";

  return (
    <button
      id={id}
      onClick={onClick}
      className={`${styles.base} ${styles.size[size]} ${variantStyles[variant]} ${className}`}
      disabled={disabled}
    >
      {Icon && iconPosition === "left" && (
        <div className={styles.iconWrapper} id={`${id}-icon-left`}>
          <Icon color={iconColor} size={16} />
        </div>
      )}
      {children}
      {Icon && iconPosition === "right" && (
        <div className={styles.iconWrapper} id={`${id}-icon-right`}>
          <Icon color={iconColor} size={16} />
        </div>
      )}
    </button>
  );
};
